<template>
  <v-container fill-height>
    <v-layout align-center justify-center>
      <v-flex xs12 md6 xl4>
        <v-card light>
          <v-toolbar dark>
            <v-toolbar-title>重設密碼</v-toolbar-title>
          </v-toolbar>

          <v-form v-model="valid" @submit.prevent="request">
            <v-card-text>
              <v-text-field
                v-model="form.email"
                :rules="[formRules.required, formRules.email]"
                label="帳號信箱"
                outlined
                prepend-inner-icon="mdi-account"
              ></v-text-field>

              <v-btn type="submit" :disabled="!valid" outlined large block class="mb-3">送出</v-btn>
            </v-card-text>
          </v-form>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>



<script>
import { mapState, mapActions } from "vuex";

import adminApi from "@/api/admin";

export default {
  components: {},

  mixins: [],

  props: [],
  data() {
    return {
      valid: false,

      form: {
        email: ""
      }
    };
  },

  computed: {},
  watch: {},
  methods: {
    ...mapActions("system", ["set_snackbar"]),

    request() {
      adminApi
        .requestPassword(this.form)
        .then(res => {
          if (res.status !== 0) {
            this.set_snackbar({
              color: "error",
              text: res.message
            });
            return;
          }

          this.$router.push("/password");
        })
        .catch(err => {});
    }
  },

  mounted() {}
};
</script>

<style lang="scss" scoped>
</style>
